const classByWidth = (width) => {
	switch(width) {
		case '100%':
			return 'col-lg-12';
		case '66%':
			return 'col-lg-8 col-md-6 col-sm-12';
		case '50%':
			return 'col-lg-6 col-sx-12';
		case '33%':
			return 'col-lg-4 col-md-6 col-sm-12';
		case 'Medarbetare':
			return 'col-lg-4 col-md-6 col-sm-12 medarbetare'
		default:
			return null;
	}
}

export default classByWidth;



// WEBPACK FOOTER //
// ./src/utils/classByWidth.js